import assetPath from '/app/packages/lebenslauf/articles/src/assets/bewerbungsschreiben-ausbildung.jpeg';
export default [globalThis.crate.assetsBaseUrl, assetPath].join('/')